// src/utils/imageFormat.js
export function convertFileToJpeg(file, quality = 0.9) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(
        blob => {
          URL.revokeObjectURL(url);
          if (!blob) return reject(new Error('Conversion falló'));
          // Reemplazamos extensión por .jpg
          const newFile = new File([blob], file.name.replace(/\.\w+$/, '.jpg'), {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          resolve(newFile);
        },
        'image/jpeg',
        quality
      );
    };
    img.onerror = err => {
      URL.revokeObjectURL(url);
      reject(err);
    };
  });
}
